import React from "react";

const LocationIco = () => {
    return (
        <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.99999 15.043C4.91736 14.1453 3.91387 13.1613 2.99999 12.101C1.62857 10.5089 7.53336e-07 8.13765 7.53336e-07 5.87809C-0.000594015 4.72411 0.351007 3.59591 1.01031 2.63624C1.66961 1.67658 2.60697 0.928603 3.70376 0.486972C4.80056 0.0453406 6.00748 -0.0700924 7.1718 0.155282C8.33611 0.380656 9.40547 0.936705 10.2445 1.75306C10.8032 2.29367 11.246 2.93661 11.5473 3.64467C11.8486 4.35273 12.0025 5.11185 12 5.87809C12 8.13765 10.3714 10.5089 8.99998 12.101C8.0861 13.1613 7.0826 14.1453 5.99999 15.043ZM5.99999 1.71223C4.86376 1.71356 3.77447 2.15288 2.97104 2.93385C2.16761 3.71481 1.71564 4.77364 1.71428 5.87809C1.71428 6.84957 2.166 8.53174 4.3157 11.0321C4.84553 11.647 5.4077 12.2349 5.99999 12.7934C6.59228 12.2355 7.15474 11.6485 7.68512 11.0346C9.83397 8.5309 10.2857 6.84873 10.2857 5.87809C10.2843 4.77364 9.83236 3.71481 9.02893 2.93385C8.2255 2.15288 7.13621 1.71356 5.99999 1.71223ZM5.99999 8.3776C5.318 8.3776 4.66395 8.11426 4.18172 7.64551C3.69948 7.17676 3.42856 6.541 3.42856 5.87809C3.42856 5.21518 3.69948 4.57942 4.18172 4.11067C4.66395 3.64192 5.318 3.37858 5.99999 3.37858C6.68197 3.37858 7.33602 3.64192 7.81826 4.11067C8.30049 4.57942 8.57141 5.21518 8.57141 5.87809C8.57141 6.541 8.30049 7.17676 7.81826 7.64551C7.33602 8.11426 6.68197 8.3776 5.99999 8.3776Z"
                fill="#FF5487"
            />
        </svg>
    );
};

export default LocationIco;
